import { render } from "./TheProfessionalTreatmentChangePhaseModal.vue?vue&type=template&id=6afc2920&ts=true"
import script from "./TheProfessionalTreatmentChangePhaseModal.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalTreatmentChangePhaseModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__